import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { DiscountDetailDto } from '@/features/dashboard/discounts/types/DiscountDetailDto.ts';
import { DiscountListDto } from '@/features/dashboard/discounts/types/DiscountListDto.ts';
import { CreateDiscountDto } from '@/features/dashboard/discounts/types/CreateDiscountDto.ts';
import { UpdateDiscountDto } from '@/features/dashboard/discounts/types/UpdateDiscountDto.ts';

const discountsApi = {
  create: async (dto: CreateDiscountDto): Promise<DiscountDetailDto> => {
    return await fetchPrivateApi<DiscountDetailDto>('POST', 'discounts', dto);
  },

  update: async (
    discountId: string,
    dto: UpdateDiscountDto,
  ): Promise<DiscountDetailDto> => {
    return await fetchPrivateApi<DiscountDetailDto>(
      'PUT',
      `discounts/${discountId}`,
      dto,
    );
  },

  get: async (discountId: string): Promise<DiscountDetailDto> => {
    return await fetchPrivateApi<DiscountDetailDto>(
      'GET',
      `discounts/${discountId}`,
    );
  },

  remove: async (discountId: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `discounts/${discountId}`);
  },

  activate: async (discountId: string): Promise<DiscountDetailDto> => {
    return await fetchPrivateApi<DiscountDetailDto>(
      'PATCH',
      `discounts/${discountId}/activate`,
    );
  },

  deactivate: async (discountId: string): Promise<DiscountDetailDto> => {
    return await fetchPrivateApi<DiscountDetailDto>(
      'PATCH',
      `discounts/${discountId}/deactivate`,
    );
  },

  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<DiscountListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<DiscountListDto>>(
      'POST',
      `discounts/all?${params.toString()}`,
      filterCriteria,
    );
  },

  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      'discounts/table-definition',
    );
  },
};

export default discountsApi;
